import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseStateService } from '@nebalkon-workspace/base-state';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationsService extends BaseStateService<boolean> {
  readonly #translateService = inject(TranslateService);

  public constructor() {
    super();
    this.listenTranslationLoaded();
  }

  private listenTranslationLoaded(): void {
    this.#translateService.get('_').pipe(take(1)).subscribe({
      next: () => this.setValue(true),
      error: () => this.setValue(true),
    });
  }
}
